import {NetworkStrategy} from './NetworkStrategy'

export class NeoXNetwork implements NetworkStrategy {
  buildPayload(params: any) {
    return {
      to: params.to,
      data: params.data,
      chainId: params.chainId,
    }
  }
}
